module.exports = __webpack_public_path__ + "media/scholarship_winners/michelle-sw-42a38d99.png";